import { insert } from "../data/Files";

let insertFile = async (layoutId, fileName, fileContent) => {
  //const valid = await validateCode("insert");
  const valid = true;
  return new Promise(async (resolve) => {
    try {
      await insert(layoutId, fileName, fileContent);
    } catch (e) {
      resolve({ error: true, msg: "Erro na importação do arquivo" });
    }
    resolve({ error: false, msg: "Arquivo importado" });
  });
};

export { insertFile };
